import { HttpTypes } from '@/types';
import { AdminBlogCreateResponse } from '@/types/http/blog/blog';
import { AdminBlogUpdateResponse } from '@/types/http/blog/blog';
import { AdminBlogDeleteResponse } from '@/types/http/blog/blog';
import { BaseBlog } from '@/types/http/blog/blog/common';
import { AxiosInstance } from 'axios';

class Blogs {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async list(queryParams: HttpTypes.FindParams): Promise<HttpTypes.IResponse<BaseBlog[]>> {
    const result = await this.client.get('/sites/blog', {
      params: queryParams,
    });
    return result.data;
  }

  async create(data: HttpTypes.AdminBlog): Promise<HttpTypes.IResponse<AdminBlogCreateResponse>> {
    const result = await this.client.post('/sites/blog', data);
    return result.data;
  }

  async detail(id: string): Promise<HttpTypes.IResponse<BaseBlog>> {
    const result = await this.client.get(`/sites/blog/${id}`);
    return result.data;
  }

  async update(data: HttpTypes.AdminBlog): Promise<HttpTypes.IResponse<AdminBlogUpdateResponse>> {
    const result = await this.client.put(`/sites/blog/${data.blog_id}`, data);
    return result.data;
  }

  async delete(id: string): Promise<HttpTypes.IResponse<AdminBlogDeleteResponse>> {
    const result = await this.client.delete(`/sites/blog/${id}`);
    return result.data;
  }
  async duplicate(name: string) {
    const result = await this.client.get('/sites/blog/check-duplicate', {
      params: {
        name,
      },
    });
    return result.data;
  }
}

export default Blogs;
